import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AddToSlackButton, DetailsPanel } from './components';
import { Root } from './UiAddToSlackSection.styles';
import { AnalyticsAttributesProvider, useAnalytics } from '../../components';
export default function UiAddToSlackSection({ model: { content: { entryTitle, buttonText, loginText, selectTeamText, noTeamText }, type, id }, initialIsOpen = false }) {
    const { sendTrackEvent } = useAnalytics();
    const [isOpen, setIsOpen] = useState(initialIsOpen);
    return (_jsx(AnalyticsAttributesProvider, Object.assign({ value: {
            eventContainer: type,
            parentLabel: entryTitle
        } }, { children: _jsxs(Root, { children: [_jsx(AddToSlackButton, { text: buttonText, onClick: () => {
                        setIsOpen(true);
                        sendTrackEvent('clickedAddToSlackButton', {
                            eventContainer: type,
                            eventComponent: 'button',
                            event: 'clicked',
                            label: entryTitle,
                            labelEnglish: entryTitle,
                            uuid: id
                        });
                    } }, void 0), _jsx(DetailsPanel, { isOpen: isOpen, loginText: loginText, selectTeamText: selectTeamText, noTeamText: noTeamText }, void 0)] }, void 0) }), void 0));
}
//# sourceMappingURL=UiAddToSlackSection.js.map